import React, { FC } from 'react';
import { SectionProps } from '#/containers/asideNavigation/Sections';
import { useI18n } from '#hooks/useI18n';
import { Can } from '#/components/roles/Can';
import { NavigationLink } from '#/containers/asideNavigation/components/NavigationLink';
import { Private } from '#/containers/router/routes/Private';

interface TaxesProps extends SectionProps {
}

export const Taxes: FC<TaxesProps> = ({ onClickItem, depth, isMobile }) => {
  const { t } = useI18n();
  return <Can hasRoles={['ownerManager', 'ownerMiddle']} hideFromZazumeUser>
    <NavigationLink to={Private.OWNER_TAXES.route} icon="employment" title={t('ownerTaxes.title')} onClick={onClickItem} depth={depth} isMobile={isMobile}/>
  </Can>;
};
